import { convertTo12HourFormat } from '@/utils/formatTime';

/**
 * 🕒 Returns formatted delivery hours for the current day.
 * @param {Object} store - Jane store data object with `delivery_hours` array.
 * @returns {string|null} - Formatted string like "10:00 AM – 8:00 PM" or null if unavailable.
 */

export function getTodayDeliveryHours(store) {
  if (!store?.delivery_hours) return null;

  const today = new Date().toLocaleDateString('en-US', { weekday: 'long' }).toLowerCase();
  const todayHours = store.delivery_hours.find((h) => h.day === today);

  return todayHours
    ? `${convertTo12HourFormat(todayHours.period.from)} – ${convertTo12HourFormat(todayHours.period.to)}`
    : null;
}